import { render, staticRenderFns } from "./NewTransaction.vue?vue&type=template&id=466b24dc&"
import script from "./NewTransaction.vue?vue&type=script&lang=js&"
export * from "./NewTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports